import { FontAwesome5 } from '@expo/vector-icons';
import {
  OEModal,
  OEText,
  BackButton,
  mr,
  flex,
} from '@openeducation/oe-it-components';
import { styled } from '@openeducation/oe-it-themes';
import { useEffect, useState } from 'react';
import { View } from 'react-native';

export interface StudentListItem {
  name: string;
}
export interface ClassStudentsModalProps {
  onClose: () => void;
  students: StudentListItem[];
}

export const ClassStudentsModal = ({
  onClose,
  students,
}: ClassStudentsModalProps) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (students?.length > 0) {
      setVisible(true);
      return;
    }
    setVisible(false);
  }, [students]);

  return (
    <Modal visible={visible} onClose={onClose}>
      <Header>
        <BackButton onPress={onClose} size={16} />
        <Title>Students ({students?.length || 0})</Title>
      </Header>

      <StudentList>
        {students?.map((student) => (
          <View
            key={student.name}
            style={flex('flex-row', 'align-items-center')}
          >
            <FontAwesome5 size={15} style={mr(4)} solid name="user" />
            <OEText fontSize={18}>{student.name}</OEText>
          </View>
        ))}
      </StudentList>
    </Modal>
  );
};

const StudentList = styled.ScrollView`
  max-height: 400px;
`;

const Modal = styled(OEModal)`
  width: 600px;
  padding: 40px;
`;

const Header = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const Title = styled(OEText).attrs({
  fontType: 'bold',
  fontSize: 20,
})`
  text-align: center;
  width: 100%;
`;
